export default __webpack_public_path__ + "static/media/preview.13384ea2.jpg";